import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import "../dist/css-styles.css";
export const CSSProvider = ({ children, className = "" }) => {
    useEffect(() => {
        document.documentElement.setAttribute("data-ps-css-loaded", "true");
        return () => {
            document.documentElement.removeAttribute("data-ps-css-loaded");
        };
    }, []);
    return (_jsx("div", { className: `ps-css-styles-root ${className}`.trim(), "data-ps-css-provider": "true", children: children }));
};
export default CSSProvider;
